if (!customElements.get('countdown-banner')) {
	class CountdownBanner extends HTMLElement {
	  constructor() {
		super();
  
		const timezone = this.dataset.timezone || 'UTC';
		const dateParts = this.dataset.date.split('-');
		
		// Detect correct format (YYYY-MM-DD or DD-MM-YYYY)
		let year, month, day;
		if (parseInt(dateParts[0]) > 31) {  
		  // Likely YYYY-MM-DD format
		  year = parseInt(dateParts[0]);
		  month = parseInt(dateParts[1]);
		  day = parseInt(dateParts[2]);
		} else {
		  // Likely DD-MM-YYYY format
		  day = parseInt(dateParts[0]);
		  month = parseInt(dateParts[1]);
		  year = parseInt(dateParts[2]);
		}
  
		let time = this.dataset.time || "00:00",
			[tarhour, tarmin] = time.split(':').map(Number);
  
		// ✅ Proper UTC Date Conversion
		this.countDownDate = new Date(Date.UTC(year, month - 1, day, tarhour, tarmin, 0)).getTime();
	  }
  
	  connectedCallback() {
		const daysEl = this.querySelector('.announcement-days'),
			  hoursEl = this.querySelector('.announcement-hours'),
			  minutesEl = this.querySelector('.announcement-minutes'),
			  secondsEl = this.querySelector('.announcement-seconds');
  
		if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
		  console.error("Countdown elements not found in the DOM.");
		  return;
		}
  
		const updateTime = () => {
		  const now = Date.now();
		  const distance = this.countDownDate - now;
  
		  if (distance < 0) {
			daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
			return;
		  }
  
		  const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
				hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
				minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
				seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
		  daysEl.textContent = CountdownBanner.addZero(days);
		  hoursEl.textContent = CountdownBanner.addZero(hours);
		  minutesEl.textContent = CountdownBanner.addZero(minutes);
		  secondsEl.textContent = CountdownBanner.addZero(seconds);
  
		  requestAnimationFrame(updateTime);
		};
  
		requestAnimationFrame(updateTime);
	  }
  
	  static addZero(x) {
		return x < 10 && x >= 0 ? '0' + x : x;
	  }
	}
  
	customElements.define('countdown-banner', CountdownBanner);
  }
  